import { SITE_URL } from './seoConfig';
import { getCanonicalUrl } from './urlUtils';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Connecto',
  alternateName: 'كونكتو',
  url: getCanonicalUrl('/'),
  logo: `${SITE_URL}/logo192.png`,
  description: 'Unified e-commerce management platform for Amazon, Noon, Jumia, and Trendyol.',
  sameAs: [
    'https://www.facebook.com/connecto.business',
    'https://www.linkedin.com/company/connecto-me/',
    'https://www.youtube.com/channel/UCMasx3Wn4jn89xgbPemBqig',
  ],
};

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Connecto',
  alternateName: 'كونكتو',
  url: getCanonicalUrl('/'),
};

export const softwareApplicationSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Connecto',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description: 'Unified e-commerce management platform integrating Amazon, Noon, Jumia, and Trendyol.',
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'USD',
    lowPrice: '0',
    offerCount: '3',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '124',
  },
};

export const createBreadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: getCanonicalUrl(item.path),
  })),
});

export const createFaqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
});

export const createReviewSchema = (reviews) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: reviews.map((review, index) => ({
    '@type': 'Review',
    position: index + 1,
    itemReviewed: {
      '@type': 'Organization',
      name: 'Connecto',
      url: getCanonicalUrl('/'),
      image: `${SITE_URL}/logo192.png`,
    },
    author: {
      '@type': 'Person',
      name: review.name,
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review.rating,
      bestRating: '5',
    },
    reviewBody: review.text,
    datePublished: review.date,
  })),
});

export const createServiceSchema = ({ language = 'ar', name, description } = {}) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: name || (language === 'ar' ? 'إدارة حسابات المتاجر الإلكترونية' : 'Marketplace Account Management'),
  provider: {
    '@type': 'Organization',
    name: 'Connecto',
    url: getCanonicalUrl('/'),
  },
  areaServed: ['EG', 'SA', 'AE'],
  description: description || (language === 'ar'
    ? 'إدارة متكاملة لحسابات المتاجر الإلكترونية على أمازون ونون وجوميا وترينديول'
    : 'Comprehensive marketplace account management across Amazon, Noon, Jumia, and Trendyol'),
});
